export default "__VITE_ASSET__DRdEAIm1__"